import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LoanList from '../components/loans/LoanList';
import LoanForm from '../components/loans/LoanForm';
import LoanDetails from '../components/loans/LoanDetails';
import { Loan } from '../services/loansService';

// Create a query client for this page
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const LoansPage: React.FC = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState<Loan | null>(null);
  const [selectedLoanId, setSelectedLoanId] = useState<string | null>(null);

  const handleCreateLoan = () => {
    setSelectedLoan(null);
    setFormOpen(true);
  };

  const handleEditLoan = (loan: Loan) => {
    setSelectedLoan(loan);
    setFormOpen(true);
  };

  const handleViewLoan = (loan: Loan) => {
    setSelectedLoanId(loan.id);
    setDetailsOpen(true);
  };

  const handleCloseForm = () => {
    setFormOpen(false);
    setSelectedLoan(null);
  };

  const handleCloseDetails = () => {
    setDetailsOpen(false);
    setSelectedLoanId(null);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold' }}>
          Loan Management
        </Typography>
        
        <LoanList
          onCreateLoan={handleCreateLoan}
          onEditLoan={handleEditLoan}
          onViewLoan={handleViewLoan}
        />

        <LoanForm
          open={formOpen}
          onClose={handleCloseForm}
          loan={selectedLoan}
        />

        <LoanDetails
          open={detailsOpen}
          onClose={handleCloseDetails}
          loanId={selectedLoanId}
          onEdit={handleEditLoan}
        />
      </Box>
    </QueryClientProvider>
  );
};

export default LoansPage;